import {
  useCollectionItemQuery,
  useCollectionsQueries,
} from "../../../hooks/queries/useCollectionsQueries";
import { LearningSetTypes } from "../../../interfaces/AthenaResources";
import { Pagetype } from "../../../interfaces/Config";
import useWorkModeEntryLearningSetIds from "../hooks/useWorkModeEntryLearningSetIds";

export const useWorkshops = (
  opts?: Parameters<typeof useCollectionsQueries>[2],
) => {
  const workshopCollectionsIds = useWorkModeEntryLearningSetIds(
    Pagetype.WORKMODE_WORKSHOP,
  );
  return useCollectionsQueries(
    LearningSetTypes.Workshop,
    workshopCollectionsIds,
    opts,
  );
};

export const useWorkshop = (id: string | undefined) => {
  return useCollectionItemQuery(LearningSetTypes.Workshop, id);
};
